import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
type ContentCardProps = {
  icon?: BoxIcon;
  number?: number;
  title: string;
  description: string;
  variant?: 'default' | 'warning' | 'tip' | 'important';
};
const variantStyles = {
  default: {
    bg: 'bg-[#1a1a1a]',
    border: 'border-[#2a2a2a]',
    iconBg: 'bg-[#252525]',
    iconColor: 'text-[#d4a853]',
    numberColor: 'text-[#d4a853]'
  },
  warning: {
    bg: 'bg-[#1a1a1a]',
    border: 'border-[#dc2626]/30',
    iconBg: 'bg-[#dc2626]/10',
    iconColor: 'text-[#dc2626]',
    numberColor: 'text-[#dc2626]'
  },
  tip: {
    bg: 'bg-[#1a1a1a]',
    border: 'border-[#22c55e]/30',
    iconBg: 'bg-[#22c55e]/10',
    iconColor: 'text-[#22c55e]',
    numberColor: 'text-[#22c55e]'
  },
  important: {
    bg: 'bg-[#252525]',
    border: 'border-[#d4a853]/30',
    iconBg: 'bg-[#d4a853]/10',
    iconColor: 'text-[#d4a853]',
    numberColor: 'text-[#d4a853]'
  }
};
export function ContentCard({
  icon: Icon,
  number,
  title,
  description,
  variant = 'default'
}: ContentCardProps) {
  const styles = variantStyles[variant];
  return <motion.div className={`${styles.bg} ${styles.border} border rounded-2xl p-4`} initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3
  }} data-id="element-33">
      <div className="flex gap-4" data-id="element-34">
        {(Icon || number !== undefined) && <div className={`${styles.iconBg} w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0`} data-id="element-35">
            {Icon ? <Icon className={`w-6 h-6 ${styles.iconColor}`} data-id="element-36" /> : <span className={`text-xl font-bold ${styles.numberColor}`} data-id="element-37">
                {number}
              </span>}
          </div>}
        <div className="flex-1 min-w-0" data-id="element-38">
          <h3 className="font-semibold text-white mb-1" data-id="element-39">{title}</h3>
          <p className="text-sm text-[#a3a3a3] leading-relaxed" data-id="element-40">
            {description}
          </p>
        </div>
      </div>
    </motion.div>;
}